import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons"
import { NAIRA } from "../../defaults/utilities";
import { formatCurrency } from "../../helpers/currency";
import { useState, useRef } from 'react';
import { Form, Input, Button, InputNumber, Space, Select, message, Row, Col } from "antd";
import DataTable from "../common/table";
import { useCreateBudget } from "../../hooks/budget/budgetQuery";
import { useFetchAllFinancialYears } from "../../hooks/financialYear/financialYearQuery";
import { extractValueFromInputRef } from "../../helpers/dom";
import { useGetMemoScope } from "../../hooks/memo-scopes/memoScopeQuery";
import { userStore } from "../../store/userStore";
import { useGetAlltBudgetItems } from "../../hooks/budgetItem/budgetItemQuery";
import { useDepartments } from "../../hooks/department/departmentQuery";


const { Option } = Select;

let index = 1;

export const DUMMY_BUDGET_ITEMS_DATA = [
    {
        label: 'procurement of systems',
        value: 'procurement of systems'
    },
    {
        label: 'allowances',
        value: 'allowances'
    },
    {
        label: 'welfare',
        value: 'welfare'
    },
    {
        label: 'support',
        value: 'support'
    },
    {
        label: 'miscellaneous',
        value: 'miscellaneous'
    }
]




export default function CreateBudgetComponent({ toggleOpen, budget, setBudget }) {
    const [item, setItem] = useState({});
    const [items, setItems] = useState([]);
    const [year, setYear] = useState("");
    const [total, setTotal] = useState(0);
    // const [department, setDepartment] = useState(null);

    const titleRef = useRef(null);

    const user = userStore(state => state.user);
    const { budgetItems } = useGetAlltBudgetItems();

    const createBudget = useCreateBudget();
    const { years } = useFetchAllFinancialYears();
    const scopes = useGetMemoScope()
    const { departments } = useDepartments();

    const createBudgetItemColumns = [
        {
            title: 'Item',
            key: 'item',
            dataIndex: 'budgetItem',
            render: (item) => JSON.parse(item).title
        },
        {
            title: 'Amount',
            key: 'amount',
            dataIndex: 'amount',
            render: (amount) => `${NAIRA} ${formatCurrency(amount)}`
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, __, idx) => (
                <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                    <Button type="primary" style={{ backgroundColor: "red" }} onClick={() => removeItem(idx)}>Remove Item</Button>
                </div>
            )
        }
    ]


    function removeItem(id) {
        const item = items.find((_, itemIndex) => itemIndex === id);
        setTotal(prevTotal => prevTotal -= +(item.amount));
        setItems((prevItems) => (prevItems.filter((_, idx) => idx !== id)))
    }



    function addItem(callback1, callback2) {
        // setItem((prev)=>({...prev,id:index}));
        setItems((prev) => {
            return [...prev, item]
        });
        setTotal(prevTotal => prevTotal += +(item.amount));
        setItem({});
        callback1()
        callback2();
        index++;
    }


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            financialYear: year,
            budgetItems: items.map(i => ({ ...i, budgetItem: JSON.parse(i.budgetItem).id })),
            userId: user.id,
            // departmentId: department,
        }
        const { message: response } = await createBudget(payload);
        message.success(response ?? "budget created successfully")
        toggleOpen();
    }


    return (
        <>
            <div style={{ marginTop: "3em", maxWidth: "65vw", maxHeight: "70vh", overflowY: "scroll", paddingLeft: ".5em", paddingRight: ".5em" }}>
                <Form style={{marginTop: '10px'}}>
                    <Form.Item>
                        <Input placeholder="Budget Name" ref={titleRef} />
                    </Form.Item>
                    <Form.Item>
                        <Select placeholder='Select financial year' onChange={(e) => setYear(e)}>
                            {
                                years.map((y, idx) => (
                                    <Option value={y.id} key={idx}>{y.value}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>

                    {
                        items.length > 0 && (
                            <DataTable cols={createBudgetItemColumns} data={items} pagination={false} rowKey={(item) => item.budgetItem.id} style={{ marginBottom: '10px' }} />
                        )
                    }
                    <Form.List name="items" style={{ width: '100%' }}>
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                        key={key}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 8,
                                            marginTop: 4,
                                            width: '100%',
                                            justifyContent: 'space-between'
                                        }}
                                        align="baseline"
                                    >
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'Item']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Missing Budget Item',
                                                },
                                            ]}
                                        >
                                            <Select 
                                            placeholder='Item' 
                                            style={{ width: '20em' }} 
                                            onChange={(e) => setItem((prevItem) => ({ ...prevItem, budgetItem: e }))}
                                            showSearch
                                            filterOption={(input, option) => 
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            >
                                                {
                                                    budgetItems.length > 0 && (
                                                        budgetItems.map((item, idx) => (
                                                            <Option value={JSON.stringify({ id: item.id, value: item.value, title: item.title })} key={idx}>{item.title}</Option>
                                                        ))
                                                    )
                                                }
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'Amount']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Missing Budget Amount',
                                                },
                                            ]}
                                        >
                                            <InputNumber style={{ width: '100%' }} prefix={NAIRA} onChange={(e) => setItem((prevItem) => ({ ...prevItem, amount: e }))} placeholder="Budget Item Amount" />
                                        </Form.Item>
                                        <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                                            <Form.Item>
                                                <Button type='primary' style={{ backgroundColor: 'lime' }} onClick={() => addItem(() => remove(name), add)}>
                                                    Add Item
                                                </Button>
                                            </Form.Item>
                                            <MinusCircleOutlined onClick={() => remove(name)} style={{ marginTop: ".5em", marginLeft: "4px" }} />
                                        </div>
                                    </Space>
                                ))}
                                <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                                    <span style={{ fontWeight: 'bold' }}>Total : {NAIRA} {total}</span>
                                </div>
                                <Form.Item>
                                    <Button type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                                        {items.length < 1 ? 'Add Budget Item' : 'Add Another Item'}
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                    <Form.Item wrapperCol={{
                        span: 8,
                        offset: 20
                    }}>
                        <Button type="primary" style={{ backgroundColor: 'green' }} onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
};
